var map = {
	"./favicon.ico": 307,
	"./ketab.png": 308,
	"./logo-danger.png": 309,
	"./logo-dark.png": 310,
	"./logo-info.png": 311,
	"./logo-primary.png": 312,
	"./logo-success.png": 313,
	"./logo-warning.png": 314,
	"./logo.png": 315,
	"./logo.svg": 316,
	"./logo1.png": 317,
	"./logo1.svg": 318,
	"./logo2.svg": 319,
	"./vuexy-logo.png": 320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;